import {
    DEFAULT_COUNT_ON_PAGE,
    DEFAULT_COUNT_ON_PAGE_THREE_COLUMNS,
    ENDLESS_PAGINATION,
} from '@shared/ui/pagination/constants';
import {
    CRMInterestsProductsDataRequest,
    CRMProductsDataRequest,
    ProductsListDataRequest,
    ProductTypesListDataRequest,
    UserProductsListDataRequest,
} from '../api/product-types';
import { RequestStatus } from '@shared/model/request';
import { DefaultSortOptionValues } from '@shared/ui/dropdown-sort/types';

export const DEFAULT_PRODUCTS_LIST_PARAMETERS: ProductsListDataRequest = {
    search: '',
    take: DEFAULT_COUNT_ON_PAGE_THREE_COLUMNS.value,
    skip: null,
};

export const DEFAULT_USER_COMPLETED_PRODUCTS_LIST_PARAMETERS: UserProductsListDataRequest = {
    userId: 0,
    search: '',
    take: DEFAULT_COUNT_ON_PAGE_THREE_COLUMNS.value,
    skip: null,
    requestStatuses: [RequestStatus.Completed],
    sort: 'desc',
    order: 'created_at',
};

export const DEFAULT_USER_ON_REVIEW_PRODUCTS_LIST_PARAMETERS: UserProductsListDataRequest = {
    userId: 0,
    search: '',
    take: DEFAULT_COUNT_ON_PAGE_THREE_COLUMNS.value,
    skip: null,
    requestStatuses: [RequestStatus.New, RequestStatus.OnPayment, RequestStatus.OrderForming],
    sort: 'desc',
    order: 'created_at',
};

export const DEFAULT_ADMIN_PRODUCTS_LIST_PARAMETERS: ProductsListDataRequest = {
    search: '',
    take: DEFAULT_COUNT_ON_PAGE.value,
    skip: null,
    sort: 'desc',
    order: 'created_at',
};

export const DEFAULT_PRODUCT_TYPES_LIST_PARAMETERS: ProductTypesListDataRequest = {
    search: '',
    take: DEFAULT_COUNT_ON_PAGE.value,
    skip: null,
};

export const DEFAULT_CRM_INTERESTS_PRODUCTS_LIST_PARAMETERS: CRMInterestsProductsDataRequest = {
    search: '',
    take: DEFAULT_COUNT_ON_PAGE.value,
    skip: null,
    sort: DefaultSortOptionValues.New,
    order: 'id',
};

export const DEFAULT_CRM_PRODUCTS_LIST_PARAMETERS: CRMProductsDataRequest = {
    search: '',
    take: DEFAULT_COUNT_ON_PAGE.value,
    skip: null,
    sort: DefaultSortOptionValues.New,
    order: 'external_id',
};

export const DEFAULT_PRODUCT_TYPES_INFINITY_LIST_PARAMETERS: ProductTypesListDataRequest = {
    take: ENDLESS_PAGINATION,
};
